import React from 'react';

const AssessmentIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.9875 2.0124C15.1185 2.1311 15.9999 3.08761 15.9999 4.25V10.75C15.9999 11.9926 14.9925 13 13.7499 13H11.4999V6C11.4999 4.61929 10.3806 3.5 8.9999 3.5H6.12793C6.4115 2.69769 7.13721 2.10424 8.0123 2.0124C8.13099 0.881447 9.08751 0 10.2499 0H11.7499C12.9123 0 13.8688 0.881448 13.9875 2.0124ZM9.4999 2.25C9.4999 1.83579 9.83569 1.5 10.2499 1.5H11.7499C12.1641 1.5 12.4999 1.83579 12.4999 2.25V2.5H9.4999V2.25Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 6C0 5.44771 0.447715 5 1 5H9C9.55228 5 10 5.44772 10 6V16C10 16.5523 9.55229 17 9 17H1C0.447716 17 0 16.5523 0 16V6ZM2 9.25C2 8.83579 2.33579 8.5 2.75 8.5H7.25C7.66421 8.5 8 8.83579 8 9.25C8 9.66421 7.66421 10 7.25 10H2.75C2.33579 10 2 9.66421 2 9.25ZM2 12.75C2 12.3358 2.33579 12 2.75 12H7.25C7.66421 12 8 12.3358 8 12.75C8 13.1642 7.66421 13.5 7.25 13.5H2.75C2.33579 13.5 2 13.1642 2 12.75Z"
      fill="currentColor"
    />
  </svg>
);

export default AssessmentIcon; 